import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AdminPanel from './AdminPanel';
import AdminPanel2 from './AdminPanel2';
import './style1.css';

interface HomeProps {
    username: string;
    onLogout?: () => void;
}

const navLinks = [
    { name: 'HOME', href: '/' },
    { name: 'PROGRAMS', href: '/programs' },
    { name: 'VIDEOS', href: '/videos' },
    { name: 'IMAGES', href: '/images' },
    { name: 'DEMOS', href: '/demos' },
    { name: 'CERTIFICATES', href: '/certificates' },
    { name: 'ABOUT', href: '/about' },
];

const Home: React.FC<HomeProps> = ({ username, onLogout }) => {
    const [menuOpen, setMenuOpen] = useState(false);

    // Example: If you ever need to fetch protected data in Home, use the token like this:
    // useEffect(() => {
    //     const token = localStorage.getItem('token');
    //     fetch('/some-protected-endpoint', {
    //         headers: {
    //             'Authorization': `Bearer ${token}`
    //         }
    //     });
    // }, []);

    return (
        <div className="modern-layout" style={{ position: 'relative' }}>
            <header className="modern-header">
                <div className="header-container">
                    <nav className={`modern-nav ${menuOpen ? 'open' : ''}`}>
                        {navLinks.map(link =>
                            link.href.startsWith('/')
                                ? <Link
                                    key={link.name}
                                    to={link.href}
                                    className="modern-nav-link"
                                    style={{ textDecoration: 'none' }}
                                  >
                                    {link.name}
                                  </Link>
                                : <a
                                    key={link.name}
                                    href={link.href}
                                    className="modern-nav-link"
                                  >
                                    {link.name}
                                  </a>
                        )}
                        <button className="logout-btn" onClick={onLogout}>LOG OUT</button>
                    </nav>
                    <button
                        className="menu-toggle"
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label="Toggle menu"
                    >
                        <span className="menu-icon">&#9776;</span>
                    </button>
                </div>
            </header>
            {/* Absolutely position AdminPanel for admin, so it does not affect main content */}
            {username === "admin" && (
                <div
                    style={{
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        bottom: 0,
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        zIndex: 10,
                        pointerEvents: 'none'
                    }}
                >
                    <div style={{ pointerEvents: 'auto' }}>
                        <AdminPanel />
                    </div>
                </div>
            )}
            {/* Absolutely position AdminPanel2 for admin, right side */}
            {username === "admin" && (
                <div
                    style={{
                        position: 'absolute',
                        right: 0,
                        top: 0,
                        bottom: 0,
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        zIndex: 10,
                        pointerEvents: 'none'
                    }}
                >
                    <div style={{ pointerEvents: 'auto' }}>
                        <AdminPanel2 />
                    </div>
                </div>
            )}
            <main className="modern-content">
                <div
                    style={{
                        maxWidth: 700,
                        margin: '2rem auto',
                        background: 'transparent',
                        borderRadius: '16px',
                        padding: '2rem',
                        color: '#222',
                        fontSize: '1.1rem'
                    }}
                >
                    <h1 style={{ textAlign: 'center', margin: 0 }}>Welcome, {username}!</h1>
                    <p style={{ textAlign: 'center', margin: 0 }}>
                        This website was a hobby project. It has been built using Spring Boot and React.
                        PostgreSQL is used as the database. I am hosting this website on a Standard_B2s virtual machine in Azure.
                        This site replaces the old website which was written in PHP and JavaScript.
                        I am hosting programs here that I have created during university courses or as a hobby.
                        These programs can be found in the "PROGRAMS" section. There are also videos and
                        images related to these programs. I have also live demos which can be found in the "DEMOS" section.
                    </p>
                </div>
            </main>
            <footer className="modern-footer">
                &copy; {new Date().getFullYear()} Timo
            </footer>
        </div>
    );
};

export default Home;